import { render, staticRenderFns } from "./InfoStatistic.vue?vue&type=template&id=5c1e267d&scoped=true"
import script from "./InfoStatistic.vue?vue&type=script&lang=js"
export * from "./InfoStatistic.vue?vue&type=script&lang=js"
import style0 from "./InfoStatistic.vue?vue&type=style&index=0&id=5c1e267d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c1e267d",
  null
  
)

export default component.exports